import { useState, useEffect } from 'react'

export const COMPACT_BREAKPOINT = 1024

export function useResponsive(breakpoint: number = COMPACT_BREAKPOINT) {
  const [isCompact, setIsCompact] = useState(false)

  useEffect(() => {
    const check = () => setIsCompact(window.innerWidth < breakpoint)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])

  return isCompact
}
